import { gql } from '@apollo/client';

export const GETPLAYER = gql`
  query getRosterMember($rosterId: String!, $uniqueId: String!, $uniqueIdType: UniqueIdType!) {
    getRosterMember(rosterId: $rosterId, uniqueId: $uniqueId, uniqueIdType: $uniqueIdType) {
      personId
      externalId
      standardGivenName
      standardFamilyName
      nationalityCode
      class
      avatarUrl
      tennisId
      worldTennisNumbers {
        confidence
        type
        tennisNumber
        isRanked
      }
    }
  }
`;
